import moment from 'moment';

//  ================
/**
 * main function to format date used all over the app
 * @param string date in sql format
 * @returns string date in format: 2020-01-01, 00:00:00 with utc appended at the end if the sql date is in utc
 */

export const formatDate = (str?: string, displayHours = false): string => {
  if (!str) return '';
  // the format jan 01, 2007
  return moment(new Date(str)).format(displayHours ? 'MMM DD, YYYY, HH:mm:ss' : 'MMM DD, YYYY');
};
